import en from './TranslationsEN'
import ja from './TranslationsJA'

// 対応言語（対応言語が増えたらリストに略字で追加する）
const supportLang = ['ja', 'en']

// jsonを結合する
var langData = Object.assign(en, ja)

export { langData, supportLang }



// WEBPACK FOOTER //
// ./src/lib/lang/index.js